var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_vm._v("\n  请点击右上角，使用至浏览器打开\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }